import { destroy,mutate,query, update } from "../../defaults/fetch";
import {useState,useEffect} from "react";

const BASE = "designation"
export const useGetAllDesignation = (flag, page = 0) => {
    const [designations, setDesignation] = useState([])
    const [totalPages, setTotalPages] = useState(0)
    const [loading, setLoading] = useState(false)
    const getAllDesignations = async () => {
        setLoading(true)
        const url = `${BASE}/get-all`
        const q = {
            page: page,
            size: 100
        }
        const { data } = await query(url, q)
        setLoading(false)
        setDesignation(data.content)
        setTotalPages(data.totalPages)
    }

    useEffect(() => {
        getAllDesignations()
    }, [flag, page])

    return {loading, designations, totalPages}
}


export const useCreateDesignation = () => {
    const createDesignation = async (body) => {
        const url = `${BASE}/create`
        const { data } = await mutate(url, true, body)
        return data
    }

    return createDesignation;
}

export const useUpdateDesignation = () => {
    const updateDesignation = async (id, body) => {
        const url = `${BASE}/update/${id}`
        const { data } = await update(url, body)
        return data
    }

    return updateDesignation;
}


export const useDeleteDesignation = ()=>{
    const deleteDesignation = async(id)=>{
        const url = `${BASE}/delete/${id}`;
        const {data} = await destroy(url);
        return data;
    }
    return deleteDesignation;
}
